<template>
  <footer class="shell-footer">
    <v-sheet color="primary" class="position-relative">
      <v-container class="py-6">
        <div class="grid-list">
          <div class="grid-list-item">
            <router-link to="/">
              <img
                v-if="informations.img"
                :src="files + informations.img"
                :height="smAndDown ? '100px' : '160px'"
                class="d-block mx-auto mx-md-0"
              />
            </router-link>
          </div>

          <div class="d-flex flex-column align-start grid-list-item">
            <div
              class="
                white--text
                text-h6 text-md-h5 text-uppercase
                font-weight-medium font-italic
                px-3
              "
            >
              Contato
            </div>

            <div v-for="(item, keyContact) in contacts" :key="keyContact">
              <v-btn
                v-if="!Array.isArray(item)"
                class="white--text text-body-2 text-none btn-contact"
                height="auto"
                min-height="36px"
                :href="item.link"
                :target="item.target"
                :title="item.name"
                depressed
                color="transparent"
              >
                <v-icon v-if="item.icon" :size="item.size" class="mr-2">
                  {{ item.icon }}
                </v-icon>

                <span v-html="item.text"></span>
              </v-btn>

              <div v-else class="d-flex flex-column align-start">
                <v-btn
                  v-for="(
                    { name, text, link, target, icon, size }, keyContactItem
                  ) in item"
                  :key="keyContactItem"
                  class="white--text text-body-2 text-none btn-contact"
                  height="auto"
                  min-height="36px"
                  :href="link"
                  :target="target"
                  :title="name"
                  depressed
                  color="transparent"
                >
                  <v-icon v-if="icon" :size="size" class="mr-2">
                    {{ icon }}
                  </v-icon>

                  <span v-html="text"></span>
                </v-btn>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column justify-space-around">
            <div class="d-flex justify-center justify-sm-end align-center">
              <div
                v-for="({ text, link, icon, size }, keySocial) in social"
                :key="keySocial"
                class="d-inline-flex"
              >
                <v-btn
                  :lass="{ 'ml-2': keySocial > 0 }"
                  :href="link"
                  target="_blank"
                  min-width="auto"
                  color="transparent"
                  :title="text"
                  depressed
                  rounded
                  small
                  fab
                >
                  <v-icon color="white" :size="size">{{ icon }}</v-icon>
                </v-btn>
              </div>
            </div>

            <div
              class="d-flex align-center justify-center justify-sm-start mt-5"
            >
              <a
                class="d-flex"
                href="https://www.mrxweb.com.br/"
                target="_blank"
              >
                <img
                  class="shell-footer-logo"
                  src="../../assets/img/mrxweb.svg"
                  alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                  title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                  height="20px"
                />
              </a>

              <v-sheet
                class="mx-4"
                color="white"
                width="1px"
                height="40px"
              ></v-sheet>

              <div class="white--text text-body-1 font-weight-regular">
                ©
                <b class="font-weight-bold"> {{ informations.name }} </b>
                {{ year }}.
                <div>Todos os direitos reservados.</div>
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr auto;
    justify-content: space-between;

    @media screen and (min-width: 600.001px) and (max-width: 960px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:first-child {
        grid-column: 1 / -1;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    .btn-contact::v-deep {
      .v-btn__content {
        max-width: 100%;
        white-space: normal;
      }
    }
  }
}
</style>
